import {
  VideoCameraOnIcon,
  MicOnIcon,
  PersonViewIcon,
  SentimentSatisfiedIcon,
  ToggleFullScreenIcon,
  ToolsIcon,
  ParticipantsIcon,
  TeleportIcon,
  ArrowLeftIcon,
} from '@icons';
import { ChatIcon } from '@core/chat/icons';
import EventSchedulerIcon from '@features/EventScheduler/components/EventSchedulerButton/EventSchedulerIcon';

export const CameraButton = {
  label: 'settingsModal.camera',
  icon: <VideoCameraOnIcon />,
};

export const MicrophoneButton = { label: 'Microphone', icon: <MicOnIcon /> };
export const ToggleViewButton = {
  label: 'tooltips.toggleView',
  icon: <PersonViewIcon />,
};

export const EventSchedulerButton = {
  label: 'eventScheduler.title',
  icon: <EventSchedulerIcon />,
};

export const ChatButton = { label: 'chatDrawer.title', icon: <ChatIcon /> };
export const CommunityButton = {
  label: 'participantsModal.community',
  icon: <ParticipantsIcon />,
};

export const ToolsButton = { label: 'actions.tools', icon: <ToolsIcon /> };
export const ReactionsButton = {
  label: 'actions.reactions',
  icon: <SentimentSatisfiedIcon />,
};
export const FullScreenButton = {
  label: 'tooltips.toggleFullScreen',
  icon: <ToggleFullScreenIcon />,
};
export const TeleportButton = {
  label: 'tooltips.teleport',
  icon: <TeleportIcon />,
};
export const CollapseExpandButton = {
  label: 'tooltips.collapseExpand',
  icon: <ArrowLeftIcon />,
};
